export default __webpack_public_path__ + "static/media/metal-album.d1602b94.jpg";